var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgTvl11E2187Ca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283px",
    height: "64px",
    viewBox: "0 0 283 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u66F2\u7EBF1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "2.6887907%",
    x2: "50%",
    y2: "91.698639%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C51FF",
    stopOpacity: 0.6,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C51FF",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-361.000000, -841.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E\\u533A",
    transform: "translate(360.000000, 745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,39.2670933 L33.5673565,28.499956 L52.1612773,33.8835247 L90.6236175,18.3360216 L127.578189,25.7523771 L143.482759,17.4535927 L189.5,26.2400321 L224.885022,17.5375907 L247.655172,23.4179888 L285,3.01639344 L285,54 C285,59.5228475 280.522847,64 275,64 L10,64 C4.4771525,64 6.76353751e-16,59.5228475 0,54 L0,39.2670933 L0,39.2670933 Z",
    id: "\\u8DEF\\u5F84-3",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    stroke: "#8C51FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.10118381e-15 38.719359 33.5673565 27.7727695 52.1612773 33.2460643 90.6236175 17.6088351 127.578189 25.1149167 143.482759 16.6778193 189.5 25.7523771 224.885022 16.7123975 247.655172 22.6908023 285 2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTvl11E2187Ca);
export default __webpack_public_path__ + "static/media/bg_tvl1.1e2187ca.1e2187ca6a062c9fe2623a22e31a9dd9.svg";
export { ForwardRef as ReactComponent };